import { assessmentFor } from '../../shared/assessment.ts';
import type { LearningSession, LessonContent } from '../../shared/types.ts';
import type { ProgressView } from '../components/WorkshopProgress.tsx';

export function progressViewFor(session:LearningSession,lesson?:LessonContent):ProgressView {
  const summary=assessmentFor(session,lesson);
  const support=Object.values(session.stages).reduce((n,p)=>n+p.hintsUsed+p.attempts.filter(a=>a.kind==='tutor').length,0);
  const award=session.workshop?.completions.at(-1);
  return {
    score:summary.understanding.score,
    label:summary.understanding.label,
    tried:summary.coverage.tried,
    total:summary.coverage.total,
    eligible:summary.eligibleForCompletion,
    activities:summary.coverage.activities.map(a=>({id:a.stageId,stageId:a.stageId,label:a.label,tried:a.tried,demonstrated:a.complete})),
    criteria:summary.checklist,
    support:`${support} hint${support===1?'':'s'} or tutor conversation${support===1?'':'s'} recorded in these activities.`,
    award:award?{grade:award.grade,earnedAt:award.awardedAt,score:award.score}:undefined,
  };
}
